/**
 * Created by razial on 2026-07-20.
 */

class ShadowNodeBridge extends BaseComponent {
    onCreate() {
        this.shadowNode = cleverapps.prefabEditor.getShadowNode(this.options.shadowNodeId);
    }

    onAttach() {
        this.shadowNode.addInstance(this.node);
    }

    onDestroy() {
        this.shadowNode.removeInstance(this.node);
    }

    getShadowNode() {
        return this.shadowNode;
    }

    getContext() {
        return this.context;
    }
}

Prefab.registerComponent("ShadowNodeBridge", ShadowNodeBridge);
